(() => {
  'use strict';

  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  const MOBILE_HOMEPAGE = window.matchMedia('(max-width: 47.9375rem)');

  const WORDMARK_SELECTORS = [
    '.hero-vermellio__wordmark-svg',
    '.footer-vermeillo__wordmark',
  ].join(',');

  const PARALLAX_SELECTORS = [
    '.hero-vermellio__visual',
    '.categories-vermeillo__visual',
    '.featured-products-vermeillo__visual',
    '.featured-editorial-vermeillo__visual',
    '.quicklook-vermeillo__card-media',
    '.collection-editorial__media',
    '.collection-editorial__mobile-media',
    '.image-with-text__media',
    '.banner__media',
  ].join(',');

  const TRANSITION_DURATION = 0.35;

  function dismissTransitionOverlay() {
    const overlay = document.getElementById('page-transition');
    if (!overlay) return;

    if (REDUCED_MOTION.matches) {
      overlay.style.display = 'none';
      return;
    }

    gsap.to(overlay, {
      opacity: 0,
      duration: TRANSITION_DURATION,
      ease: 'power2.inOut',
      onComplete() {
        overlay.style.pointerEvents = 'none';
      },
    });
  }

  function syncLenis() {
    const trySync = () => {
      const lenis = window.vermeilloLenis;
      if (!lenis) return false;

      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add((time) => lenis.raf(time * 1000));
      gsap.ticker.lagSmoothing(0);
      return true;
    };

    if (trySync()) return;

    let attempts = 0;
    const interval = setInterval(() => {
      if (trySync() || ++attempts > 40) clearInterval(interval);
    }, 150);
  }

  function initWordmarkDraw() {
    const wordmarks = document.querySelectorAll(WORDMARK_SELECTORS);
    if (!wordmarks.length) return;
    const isHomepage = Boolean(document.querySelector('sticky-header[data-is-homepage="true"]'));

    if (MOBILE_HOMEPAGE.matches && isHomepage) return;

    wordmarks.forEach((svg) => {
      svg.classList.add('js-wordmark-draw');
      const paths = svg.querySelectorAll('path');

      paths.forEach((path) => {
        const length = path.getTotalLength();
        path.style.fill = 'currentColor';
        path.style.stroke = 'currentColor';
        gsap.set(path, {
          strokeDasharray: length,
          strokeDashoffset: length,
          fillOpacity: 0,
          strokeOpacity: 1,
          strokeWidth: 1,
        });
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: svg,
          start: 'top 90%',
          once: true,
        },
      });

      tl.to(paths, {
        strokeDashoffset: 0,
        duration: 1.2,
        ease: 'power2.inOut',
        stagger: 0.05,
      }).to(
        paths,
        {
          fillOpacity: 1,
          strokeOpacity: 0,
          duration: 0.6,
          ease: 'power2.out',
        },
        '-=0.4'
      );
    });
  }

  function initParallax() {
    const containers = document.querySelectorAll(PARALLAX_SELECTORS);
    if (!containers.length) return;

    containers.forEach((container) => {
      if (container.closest('.product-editorial__media-frame') ||
          container.closest('.product-editorial__supporting-card')) {
        return;
      }

      const img = container.querySelector('img');
      if (!img) return;

      container.classList.add('js-parallax-container');
      img.classList.add('js-parallax-image');

      gsap.set(img, { scale: 1.15 });

      gsap.fromTo(
        img,
        { yPercent: -8 },
        {
          yPercent: 8,
          ease: 'none',
          scrollTrigger: {
            trigger: container,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
          },
        }
      );
    });
  }

  function initPageTransitions() {
    const overlay = document.getElementById('page-transition');
    if (!overlay) return;

    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href]');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href) return;
      if (href.startsWith('#') || href.startsWith('javascript:')) return;
      if (link.target === '_blank') return;
      if (link.hasAttribute('data-no-transition')) return;
      if (e.ctrlKey || e.metaKey || e.shiftKey) return;

      try {
        const url = new URL(href, window.location.origin);
        if (url.origin !== window.location.origin) return;
      } catch {
        return;
      }

      if (typeof Shopify !== 'undefined' && Shopify.designMode) return;

      e.preventDefault();
      overlay.style.pointerEvents = 'auto';

      gsap.to(overlay, {
        opacity: 1,
        duration: TRANSITION_DURATION,
        ease: 'power2.inOut',
        onComplete() {
          window.location.href = href;
        },
      });
    });
  }

  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    if (REDUCED_MOTION.matches) {
      const overlay = document.getElementById('page-transition');
      if (overlay) overlay.style.display = 'none';
      return;
    }

    syncLenis();
    dismissTransitionOverlay();
    initWordmarkDraw();
    initParallax();
    initPageTransitions();

    document.addEventListener('shopify:section:load', () => {
      ScrollTrigger.refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
